import type { PackSize } from '../components/PackSizesPanel';

// Example pack on fixed release dates: Palisander Club, case of 12, two releases a year
export const palisanderCaseOf12: PackSize = {
  id: 'palisander-case-12',
  number: 1,
  title: 'Palisander Club',
  subtitle: 'Manual Selection · 5 products',
  displayLabel: 'Palisander Club, Case of 12',
  quantity: '12',
  min: 12,
  max: 12,
  collectionName: 'Manual Selection',
  productCount: 5,
  productIds: ['pal-1', 'pal-2', 'pal-3', 'pal-4', 'pal-5'],
  frequencies: [],
  isExpanded: true,
  billingMode: 'releaseDates',
  cutoffDays: 30,
  releases: [{
    id: 'palisander-autumn-winter',
    month: 3,
    day: 1,
    name: 'Autumn/Winter',
    discountType: 'flat',
    discount: '',
    flatPrice: '477',
    loyaltyTier: 'None',
    adHocDiscount: '0',
    pausedDiscount: '0',
    products: {
      'pal-3': 4,
      'pal-1': 4,
      'pal-4': 2,
      'pal-2': 2
    },
    isRowExpanded: true
  }, {
    id: 'palisander-spring-summer',
    month: 9,
    day: 1,
    name: 'Spring/Summer',
    discountType: 'flat',
    discount: '',
    flatPrice: '760',
    loyaltyTier: 'None',
    adHocDiscount: '0',
    pausedDiscount: '0',
    products: {
      'pal-5': 4,
      'pal-4': 4,
      'pal-2': 4
    },
    isRowExpanded: false
  }]
};

export const initialPackSizes: PackSize[] = [palisanderCaseOf12];
